export {default as s1} from './skins/s1'
export {default as s2} from './skins/s2'
export {default as s3} from './skins/s3'
export {default as s4} from './skins/s4'
export {default as s5} from './skins/s5'
export {default as s6} from './skins/s6'
export {default as s7} from './skins/s7'
export {default as s8} from './skins/s8'
export {default as s9} from './skins/s9'
export {default as s10} from './skins/s10'
export {default as s11} from './skins/s11'
export {default as s12} from './skins/s12'
export {default as s13} from './skins/s13'
export {default as s14} from './skins/s14'
export {default as s15} from './skins/s15'
export {default as s16} from './skins/s16'
export {default as s17} from './skins/s17'
export {default as s18} from './skins/s18'